import * as ReselectModule from "reselect";
import { IClientNoteListState } from ".";
import { IApplicationState } from "..";

export const selectClientNoteList: ReselectModule.Selector<
  IApplicationState,
  IClientNoteListState
> = (state) => state.clientNoteList;
